import { connect } from 'react-redux';
import UserGroupListView from './UserGroupListView';
import { fetchUserGroups, fetchUserGroup } from 'src/legacy/redux/actions/userGroups';
import { invalidateUserSelection } from 'src/legacy/redux/actions/selection';
import { showSettingsSideMenu, hideSettingsSideMenu }
from 'src/legacy/redux/actions/settings.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks';

const mapStateToProps = (state, ownProps) => {
  return {
    userGroups: _.get(state.legacyRootReducer, "settings.userGroup.items"),
    loading: _.get(state.legacyRootReducer, "settings.userGroup.loading"),
    currentPage: _.get(state.legacyRootReducer, "settings.userGroup.pagination.current"),
    totalPages: _.get(state.legacyRootReducer, "settings.userGroup.pagination.totalPages"),
    showSettingsMenu: _.get(state.legacyRootReducer, "settings.settingsMenu.showSettingsMenu"),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu())
    },

    fetchUserGroups: (page, query) => {
      return dispatch(fetchUserGroups(page, query));
    },

    fetchUserGroup: (id) => {
      return dispatch(fetchUserGroup(id));
    },

    invalidateUserSelection:() => {
      return dispatch(invalidateUserSelection());
    }
  }
}

const UserGroupListContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(UserGroupListView);

export default withUseHooks(UserGroupListContainer);